/**
 * Remove Twilio from the message
 *
 * @param {string} message
 * @return {*}
 */
export const removeTwilioFromMessage = (message: string) => {
    return message.replaceAll(/Twilio/gi, 'Server');
};
